import React from "react";
import { Box, Typography } from "@mui/material";
import { EDITOR_ACCENT } from "../editorUiConstants";

const EditorMobileOverlay = () => (
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      zIndex: 25,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "rgba(248, 250, 252, 0.55)",
      backdropFilter: "blur(6px)",
      borderRadius: 2,
      pointerEvents: "auto",
    }}
  >
    <Box
      sx={{
        p: 3,
        mx: 2,
        maxWidth: 420,
        textAlign: "center",
        backgroundColor: "#fff",
        border: "1px solid #e2e8f0",
        borderRadius: 2,
        boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
      }}
    >
      <Typography variant="h6" sx={{ color: EDITOR_ACCENT, fontWeight: 700 }}>
        L&apos;editor è ottimizzato solo per l&apos;utilizzo in modalità desktop
      </Typography>
    </Box>
  </Box>
);

export default EditorMobileOverlay;
 